import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment as env } from '../../environments/environment';

const RETURN_TO_KEY = 'f2.admin.returnTo';

// On 401 from our authenticated REST surface, route to /login instead
// of letting the call's catch block render a misleading toast ("Failed
// to mint magic-link") for what's actually an expired session.
// Diagnosed via ER-C5ZZWFA 2026-06-30: cookieHdr.len=0 + authHeader.len=0
// at the moment of the click; cookies returned ~4min later after a
// manual re-auth. The 401 was real, just not actionable as displayed.
export const auth401Interceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const isOurApi = req.url.startsWith(`${env.apiUrl}/rest/admin/`)
                    || req.url.startsWith(`${env.apiUrl}/rest/user/`);
      const path = window.location.pathname;
      // Don't bounce when the user is already on the auth pages — the
      // Hosted UI flow's own callback exchange can land here and we
      // don't want to loop on its own intermediate errors.
      const onAuthPage = path === '/login' || path === '/callback';
      if (err?.status === 401 && isOurApi && !onAuthPage) {
        const returnTo = window.location.pathname + window.location.search;
        // Guard against open-redirect: only same-origin internal paths
        // (single leading slash, no scheme, no protocol-relative URL).
        if (returnTo.startsWith('/') && !returnTo.startsWith('//')) {
          try { sessionStorage.setItem(RETURN_TO_KEY, returnTo); } catch {}
        }
        router.navigate(['/login']);
      }
      return throwError(() => err);
    })
  );
};

export function consumeReturnTo(): string {
  try {
    const v = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    if (v && v.startsWith('/') && !v.startsWith('//')) return v;
  } catch {}
  return '/home';
}
